import React, { useEffect, useState } from "react";
import { IComment } from "interfaces/comment";
import { useReadEventComments } from "hooks/comments/event/useReadEventComments";
import { useWriteEventComment } from "hooks/comments/event/useWriteEventComment";
import { CommentFeedAccordion } from "components/Comments/CommentFeedAccordion";

interface EventCommentSectionProps {
  eventId: number;
}

export const EventCommentSection = ({
  eventId
}: EventCommentSectionProps): JSX.Element => {
  const [comments, setComments] = useState<IComment[]>([]);

  const {
    loading: commentsListLoading,
    getEventComments
  } = useReadEventComments(eventId);

  async function onCommentsChanged(): Promise<void> {
    setComments(await getEventComments());
  }

  const {
    createEventComment,
    updateEventComment,
    deleteEventComment
  } = useWriteEventComment(eventId, onCommentsChanged);

  useEffect(() => {
    onCommentsChanged();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CommentFeedAccordion
      loading={commentsListLoading}
      comments={comments}
      addComment={createEventComment}
      updateComment={updateEventComment}
      deleteComment={deleteEventComment}
    />
  );
};
